import { getAuthRoleNames } from "../services/authService";

export const ADMIN_ROLES = ["owner", "manager"];

export const OPERATIONAL_ROLES = ["owner", "manager", "receptionist", "professional"];

/** Balcão web (sem profissional / sem SDR). */
export const STUDIO_WEB_ROLES = ["owner", "manager", "receptionist"];

/**
 * Papéis com menu/rotas web de operação leve: Dashboard, Agenda, Clientes.
 * Inclui `sdr` (GAP-F1-224) — sem comandas, financeiro nem settings.
 */
export const SDR_WEB_ROLES = ["owner", "manager", "receptionist", "sdr"];

/** Agenda web: balcão + profissional + SDR. */
export const AGENDA_WEB_ROLES = [
  "owner",
  "manager",
  "receptionist",
  "professional",
  "sdr",
];

/** Clientes web: balcão + profissional + SDR. */
export const CLIENTS_WEB_ROLES = [
  "owner",
  "manager",
  "receptionist",
  "professional",
  "sdr",
];

export const canAccessOpenOrdersPanel = (roles?: string[]): boolean => {
  const userRoles = roles ?? getAuthRoleNames();

  return userRoles.some((role) => STUDIO_WEB_ROLES.includes(role));
};

/**
 * FAB de ajuda contextual (GAP-F2-099) — balcão + profissional; oculto para SDR.
 * Super Admin usa outro layout e não monta o componente.
 */
export const canAccessContextualHelp = (roles?: string[]): boolean => {
  const userRoles = roles ?? getAuthRoleNames();

  return userRoles.some((role) => OPERATIONAL_ROLES.includes(role));
};

/** SDR não pode concluir atendimento (cria comanda automática) — GAP-F1-224. */
export const canConcludeAppointments = (roles?: string[]): boolean => {
  const userRoles = roles ?? getAuthRoleNames();

  return !userRoles.includes("sdr");
};

/**
 * Marcar “Chegou” no balcão — paridade Expo (`canManageAgenda`):
 * owner / manager / receptionist / sdr (não só profissional).
 */
export const canMarkClientArrived = (roles?: string[]): boolean => {
  const userRoles = roles ?? getAuthRoleNames();

  return userRoles.some((role) =>
    ["owner", "manager", "receptionist", "sdr"].includes(role)
  );
};

export const getDefaultHomePathForRoles = (roles?: string[]): string => {
  const userRoles = roles ?? getAuthRoleNames();

  if (userRoles.some((role) => SDR_WEB_ROLES.includes(role))) {
    return "/dashboard";
  }

  if (userRoles.includes("professional")) {
    return "/agenda";
  }

  return "/dashboard";
};
